<template>
<div class="xxray flow-page">
    <div class="flow-title">
        Title
    </div>
    <div class="flow-content">
        <div class="flow-col flow-col-left">
            <span class="light-text">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem deserunt dolores magnam, saepe culpa doloribus numquam! Repellendus cumque blanditiis in iste! Commodi non aut aliquid eaque modi nobis iusto! Nihil?
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem deserunt dolores magnam, saepe culpa doloribus numquam! Repellendus cumque blanditiis in iste! Commodi non aut aliquid eaque modi nobis iusto! Nihil?
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem deserunt dolores magnam, saepe culpa doloribus numquam! Repellendus cumque blanditiis in iste! Commodi non aut aliquid eaque modi nobis iusto! Nihil?
            </span>
        </div>
        <div class="flow-col flow-col-main">
            <div class="flow-panel-outer light-text">
                <div class="flow-panel">
                    <!-- <HomeLoan class="ma-3" :homeLoan="homeLoan" /> -->
                    <div style="width:100%;border:solid 3px red">
                          <YesNo v-model="yesorno1" color="primary" label="Work Income" question="Do you receive any income from work?" />
                          <YesNo v-model="yesorno2" color="primary" label="Government Income" question="Do you receive family payments or other government income?" />
                          <YesNo v-model="yesorno2" color="primary" question="Do you receive family payments or other government income?" />
                          <YesNo v-model="yesorno2" color="primary" label="Government Income" />
                    </div>
                <v-switch />
                </div>
            </div> 
            <div class="flow-panel-outer light-text">
                <div class="flow-panel" style="margin-right:100px;">


                    <div style="border:dotted 1px green;display:flex;min-height:200px;">
                        <div style="width:50px;flex-basis:50px;text-transform:uppercase;background-color: #ddd;">
                            <div style="letter-spacing:2px;margin-left:34px;margin-top:20px;transform: rotate(90deg);transform-origin: 0 0;">
                                Identification
                            </div> 
                        </div>
                        <div style="flex-grow:1;position:relative;background-color:#eee">

                            <div style="border-radius:100px;background-color:white;padding:10px 20px;position:relative;left:30px;margin:10px" class="elevation-1">
                                Drivers license and Passport
                            </div>
                            <div style="border-radius:100px;background-color:white;padding:10px 20px;position:relative;left:30px;margin:10px" class="elevation-1">
                                Visa and proof of residency
                            </div>
                            <div style="border-radius:100px;background-color:white;padding:10px 20px;position:relative;left:30px;margin:10px" class="elevation-1">
                                Registration form (attached)
                            </div>

                        </div>
                    </div>


                </div>
            </div> 
        </div>
        <div class="flow-col flow-col-right">
            <div class="flow-panel-outer light-text">
                <div class="flow-panel">

        <!-- <iframe src="https://firebasestorage.googleapis.com/v0/b/photon-6d209.appspot.com/o/transactions%2F-MGuNNSW9gLeqvrSLh77%2FInsight%20Processing%20Matt%20Ireland%20_%20Brand%20and%20Website%20_%20July%202020%20Adaption%20Grant.pdf?alt=media&token=7bee2859-7646-40b0-b377-c22326e48dfd"
        style="width: 90%; height: 1000px">
            <p>Your browser does not support iframes.</p>
        </iframe> -->

         <object data="https://firebasestorage.googleapis.com/v0/b/photon-6d209.appspot.com/o/transactions%2F-MGuNNSW9gLeqvrSLh77%2FInsight%20Processing%20Matt%20Ireland%20_%20Brand%20and%20Website%20_%20July%202020%20Adaption%20Grant.pdf?alt=media&token=7bee2859-7646-40b0-b377-c22326e48dfd" type="application/pdf" width="500" height="500">
        alt : <a href="https://firebasestorage.googleapis.com/v0/b/photon-6d209.appspot.com/o/transactions%2F-MGuNNSW9gLeqvrSLh77%2FInsight%20Processing%20Matt%20Ireland%20_%20Brand%20and%20Website%20_%20July%202020%20Adaption%20Grant.pdf?alt=media&token=7bee2859-7646-40b0-b377-c22326e48dfd">test.pdf</a>
        </object>

                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>

import HomeLoan from '../ui-elements/HomeLoan'
import YesNo from '../ui-elements/YesNo'

export default {
    data() {
        return {
            yesorno1: null,
            yesorno2: null,
            homeLoan: {
                groups: [
                    {
                        title: 'Refinance and Cashout',
                        loans: [
                            {
                                amount: 300000,
                                lmiType: 'Capitalised',
                                lmi: 1400,
                                rate: 3.89,
                                fixed: 2,
                                io: 1,
                                description: '2y IO, 2y Fixed, Pricing, Rate Saver 3y disc.',
                                investment: false,
                            },
                            {
                                amount: 101000,
                                rate: null,
                                fixed: 0,
                                io: 0,
                                investment: false,
                            },
                        ],
                        properties: [
                            {
                                value: 504000
                            },
                            {
                                value: 255000
                            },
                        ]

                    },
                    {
                        title: 'Purchase Home',
                        loans: [
                            {
                                amount: 600000
                            },
                
                        ],
                        properties: [
            
                            {
                                value: 810000,
                                address: '45 Lime Lilly Rd, Happervalley Q 4559',
                                existing: true,
                                investment: true,
                            },
                        ]

                    },
                ]
            }
        }
    },

    components: {
        HomeLoan, YesNo
    },
    
    props: {
        
    },

    computed: {

    },

    methods: {

    },

    mounted() {
    
    }

}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// LayoutPage3.vue?3384fdc8